import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgText = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <g>
      <path
        fill={_.color}
        d="M1.09 11.063A.575.575 0 0 1 .5 10.5c0-.312.263-.562.59-.562h5.892c.327 0 .59.25.59.562a.575.575 0 0 1-.59.563zm0-3A.575.575 0 0 1 .5 7.5c0-.312.263-.562.59-.562h9.82c.327 0 .59.25.59.562a.575.575 0 0 1-.59.563zM.5 4.5c0-.312.263-.562.59-.562h5.892c.327 0 .59.25.59.562a.575.575 0 0 1-.59.563H1.09A.575.575 0 0 1 .5 4.5m.59-2.437A.575.575 0 0 1 .5 1.5c0-.312.263-.562.59-.562h9.82c.327 0 .59.25.59.562a.575.575 0 0 1-.59.563z"
      />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgText);
export default ForwardRef;
